import { Injectable } from '@angular/core';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
import { CommonConstants } from 'src/app/common/utilities/commonConstants';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClevertapEventHandlerService {
    isMobile: any = this._sessionHandlerService.GetSession('mobileState');
    constructor(
        private _sessionHandlerService: SessionHandlerService
    ) {
    }
    /**
     * Method for handling clevertap web events
     * @param eventName : event name
     * @param propertyData : event data
     */
    public clevertapEvents(eventName: string, propertyData: any) {
        if (environment.isCleverTapEnabled && this.isMobile != '1') {
            try {
                console.log("clevertap", eventName, propertyData);
                window['clevertap'].event.push(eventName, propertyData);
            } catch (error) {
                console.log('error', error);
            }
        }
    }

    /**
     * Method for logging user event 
     * @param customerId : customer id from summary call apllicationDetail
     */
    public onUserLogin(customerId) {
        if (this.isMobile != '1') {
            this.cleverTapUserCreation({
                "Identity": "+91" + this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobile_number),
                "Phone": "+91" + this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobile_number),
                "customer_tag": customerId != null ? "ETB" : "NTB",
                "customer_id": customerId || null
            });
        }
    }


    /**
     * Method for logging Product Display Page event on PLP Page
     * @param customerId : customer id from summary call apllicationDetail
     */
    public cleverTapForOnPageLoad(customerId) {
        const onPageLoadObj: any = {
            "event_type": "identity_set",
            "custom_event": "marketplace_form_event",
            "component": "marketplace_login",
            "element": "marketplace_login _cta",
            "cta_text": "GET QUOTE",
            "page_url": document.URL,
            "page_type": "Product Display Page",
            "product_name": "NA",
            "product_category": CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance,
            "customer_tag": customerId != null ? "ETB" : "NTB",
            "customer_id": customerId || null
        }
        this.clevertapEvents("click", onPageLoadObj);
    }

    /**
     * Method for logging landing page [getGoingNow] page load event
     * @param userProfileData : Event Data
     */
    public cleverTapUserCreation(userProfileData: any) {
        console.log("clevertap", 'Identity', userProfileData);
        window['clevertap'].onUserLogin.push({
            "Site": userProfileData
        })
    }

    /**
     * Method for logging PWA Events 
     * @param eventName : event name
     * @param propertyData : event data
     */
    public clevertapPwaEvents(eventName: string, propertyData: any) {
        if (environment.isCleverTapEnabled && this.isMobile == '1') {
            try {
                console.log("clevertap", eventName, propertyData);
                window['clevertap'].event.push(eventName, propertyData);
            } catch (error) {
                console.log('error', error);
            }
        }
    }
}
